<template>
  <div class="c-app bg-login flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Login</h1>
                  <p class="text-muted">Input Your Account Login</p>
                  <CAlert
                    :show.sync="dismissCountDown"
                    closeButton
                    color="info"
                    fade
                  >
                    Maaf! Username dan Password tidak boleh kosong...
                  </CAlert>
                  <CInput
                    placeholder="Username"
                    v-model="username"
                    autofocus = "true"
                    autocomplete="username email"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    v-model="password"
                    v-on:keyup.enter="loginNow"
                    autocomplete="curent-password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton
                        color="primary"
                        class="px-4"
                        v-on:click="loginNow"
                        >Login</CButton
                      >
                    </CCol>
                    <CCol col="6" class="text-right">
                      <!-- <CButton color="link" class="px-0"
                        >Forgot password?</CButton
                      > -->
                      <!-- <CButton color="link" to="/register" class="px-0"
                        >Daftar Sekarang!</CButton> -->
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody>
                <CRow>
                  <CCol>
                    <img
                  :src="require('../../assets/images/pontianak.png')"
                  style="width: 90px; margin: 10 auto" />
                  </CCol>
                  <!-- <CCol>
                    <img
                  :src="require('../../assets/images/polda.png')"
                  style="width: 90px; margin: 10 auto" />
                  </CCol> -->
                </CRow>
                <!-- <img
                  :src="require('../../assets/images/bitqueen.jpg')"
                  style="width: 110px; margin: 10 auto"
                /> -->
                <h2>SIPPohon</h2>
                <p>Sistem Informasi Database Pohon Dinas PUPR Kota Pontianak</p>
                <!-- <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                >
                  Login Sekarang!
                </CButton> -->
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <CModal title="Warning" :show.sync="myModal" size="sm">
      Maaf! Username dan Password tidak boleh kosong...
    </CModal>
    <CModal title="Warning" :show.sync="myModal2" size="sm">
      Berhasil! Anda berhasil login...
    </CModal>
  </div>
</template>
<style scoped>
  .bg-login{
    background-image: url('~@/assets/images/bg_pohon.jpg');
    background-size: cover;
    background-position: center center;
  }
</style>
<script>
import axios from "axios";
export default {
  name: "Login",
  data() {
    return {
      tabs: [],
      myModal: false,
      myModal2: false,
      users: "",
      dismissCountDown: 0,
      username: "",
      password: "",
      rcvr: "",
      activeTab: 1,
    };
  },
  mounted(){
    this.$store.commit('setLogin', false);
  },
  methods: {
    // validator (val) {
    //   return val ? val.length >= 4 : false
    // },
    loginNow: function (event) {
      // Simple POST request with a JSON body using axios
      const user = {
        email: this.username,
        password: this.password,
      };

      const formData = new FormData()
      
      // formData.append('id_informasi_pohon', this.$route.params.id_informasi_pohon)
      formData.append('username', this.username)
      formData.append('password', this.password)
      if (
        (this.username == null || this.username == "",
        this.password == null || this.password == "")
      ) {
        this.myModal = true;
      } else {
        axios
          .post(
             process.env.VUE_APP_BASE_URL+"loginapp",
            formData
          )
          .then((response) => {
            if (response.data.status == "ok") {
              localStorage.setItem("user", JSON.stringify(response.data.user));
              localStorage.setItem("jwt", response.data.access_token);
              this.users = JSON.stringify(response.data.user);
              this.$store.commit('setUsers', this.users);
              this.$store.commit('setLogin', true);
              this.$router.push("/dashboard");

              this.myModal2 = true;
            } else {
              this.myModal = true;
            }
          });
      }
    },
  },
};
</script>
